import { render, staticRenderFns } from "./ActiveCampaignsTable.vue?vue&type=template&id=46aefc5b&scoped=true"
import script from "./ActiveCampaignsTable.vue?vue&type=script&lang=js"
export * from "./ActiveCampaignsTable.vue?vue&type=script&lang=js"
import style0 from "./ActiveCampaignsTable.vue?vue&type=style&index=0&id=46aefc5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aefc5b",
  null
  
)

export default component.exports